var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Tipo_AutenticacaoActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Tipo_AutenticacaoModule = class Tipo_AutenticacaoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Tipo_AutenticacaoActions.POST_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.post("Tipo_Autenticacao/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Tipo_AutenticacaoActions.PUT_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.put("Tipo_Autenticacao/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Tipo_AutenticacaoActions.DELETE_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.delete("Tipo_Autenticacao/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Tipo_AutenticacaoActions.DELETE_RANGE_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.delete("Tipo_Autenticacao/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Tipo_AutenticacaoActions.FILTER_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.post("Tipo_Autenticacao/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Tipo_AutenticacaoActions.GET_TIPO_AUTENTICACAO]() {
        return new Promise(resolve => {
            infraService.get("Tipo_Autenticacao/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Tipo_AutenticacaoActions.GETWITHDISABLED_TIPO_AUTENTICACAO]() {
        return new Promise(resolve => {
            infraService.get("Tipo_Autenticacao/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Tipo_AutenticacaoActions.GET_BY_ID_TIPO_AUTENTICACAO](data) {
        return new Promise(resolve => {
            infraService.get("Tipo_Autenticacao/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Tipo_AutenticacaoModule.prototype, _h, null);
Tipo_AutenticacaoModule = __decorate([
    Module
], Tipo_AutenticacaoModule);
export default Tipo_AutenticacaoModule;
//# sourceMappingURL=Tipo_AutenticacaoModule.js.map